import styled from 'styled-components';

export const BestSellerDescriptionContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  background-size: cover !important;
  padding: 10px 16px;
  align-items: center;
  position: relative;

  @media (max-width: 720px) {
    justify-content: flex-start;
    flex-direction: ${(props) => props.flexDirection};
    padding: 0 14px 16px;
  }

  background: url(${(props) => props.image});
`;

export const BestSellerContent = styled.div`
  @media (max-width: 720px) {
    flex-basis: 60%;
    padding-top: 10px;
  }
  & h3 {
    color: rgb(0 0 0 / 80%);
    font-size: clamp(18px, 2vw, 24px);
    font-weight: 600;
    letter-spacing: 5px;
    @media (max-width: 720px) {
      letter-spacing: 3px;
    }
  }
  & p {
    color: #00000061;
    font-size: clamp(12px, 2vw, 13px);
    font-weight: 500;
    display: none;
  }
`;
export const BestSellerButton = styled.div`
  position: absolute;
  right: 12px;
  & div {
    max-width: 120px;
    border: none;
    outline: none;
    color: hsl(0deg, 0%, 0%, 80%);
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-weight: 500;

    @media (max-width: 720px) {
      font-weight: 600;
    }

    img {
      width: 12px;
      height: 12px;
      position: relative;
      left: 4px;
      transform: rotate(270deg);
    }
  }
`;
